import React, { useEffect } from 'react';
import { useState, Downgraded } from '@hookstate/core';
import { useEventState } from '../../../stores/eventStore';
import Helper from '../../../utility/helper';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../../constants/Constant';
import { Box } from '@mui/material';
import Title from '../../../sharedcomponents/title/title';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import CustomTabs from '../../../sharedcomponents/customTabs/customTabs';
// import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import RouteConstants from '../../../constants/routeConstants';
import AssignActivityList from './assignActivityList';
import ActivityAudit from './activityAudit';
import EmailConfiguration from '../emailConfiguration';

const CombineAssignActivitiy = () => {
    const tabValue = useState(0);
    const eventState = useEventState();

    const collectionTabs = useState([
        {
            label: 'Assign Activity Tracker',
            value: 0,
            component: AssignActivityList,
            data: [],
        },
        {
            label: 'Activity Audit',
            value: 1,
            component: ActivityAudit,
            data: [],
        },
        {
            label: 'Email Setting',
            value: 2,
            component: EmailConfiguration,
            data: [{ type: 'Assign' }],
        },
    ]);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);
    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
            else if (userInfo.roles && Helper.isEventAdmin(userInfo) || userInfo.roles && Helper.isEventStaff(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
            else {
                setModPermission(NO_ACCESS_PERMISSION);
            }
        }
    }, [eventState]);

    const handlechange = (value) => {
        tabValue.set(value);
    };
    return (
        <Box
            sx={{
                // p: 2,
                width: '100%',
            }}>
            <Box className='contentBox'>
                <Title title={"Assign Activity"} />
                {
                    modPermission && modPermission == NO_ACCESS_PERMISSION ?
                        <UnauthorizedUI showLogout={false} />
                        :
                        <CustomTabs
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            value={tabValue.get()}
                            handleChange={handlechange}
                            data={collectionTabs.attach(Downgraded).get()}
                            modPermission={modPermission}
                            removeMargin={true}
                        />
                }
            </Box>
        </Box>
    )
};

export default {
    routeProps: {
        path: RouteConstants.COMBINE_ASSIGN_ACTIVITIES,
        component: CombineAssignActivitiy,
    },
    name: 'CombineAssignActivity',
};